import { Component, OnInit, TemplateRef, ViewChild, Input } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationsService, Notification, NotificationType } from 'angular2-notifications';
import { Notificacion } from '../../../interfaces/notificacion';

@Component({
  selector: 'app-notificacion',
  templateUrl: './notificacion.component.html',
  styleUrls: ['./notificacion.component.scss']
})
export class NotificacionComponent implements OnInit {
  titulo: string;
  contenido: string;
  tipo: NotificationType;
  @Input() notificacion: Notificacion;
  private _notificacion: Notification;

  @ViewChild('templateNotificacion') templateNotificacion: TemplateRef<any>;

  constructor(
    private router: Router,
    private notificationsService: NotificationsService
  ) { }

  ngOnInit(): void {
    this.titulo = this.notificacion.titulo;
    this.contenido = this.notificacion.descripcion;
    this.tipo = this.notificacion.data.estado && this.notificacion.data.estado == 2 ? NotificationType.Error : NotificationType.Info;

    this._notificacion = this.notificationsService.html(
      this.templateNotificacion,
      this.tipo,
      {
        timeOut: 0,
        showProgressBar: false,
        pauseOnHover: true,
        clickToClose: true,
        maxLength: 10,
        animate: "fromLeft",
        id: `notificacion_${this.notificacion.id}`
      }
    );

    // On click ejecutar la acción según corresponda 
    switch (this.notificacion.data.action) {
      case "cotizacion":
      case "email_cotizacion":
        this._notificacion.click.subscribe((e: MouseEvent) => {
          this.router.navigate(['logueado/cotizacion-detalle/', this.notificacion.data.parameters.idCotizacion]);
        });
        break;
      case "orden_venta":
        this._notificacion.click.subscribe((e: MouseEvent) => {
          this.router.navigate(['logueado/detalle-ov/', this.notificacion.data.parameters.id]);
        });
        break;
      case "orden_trabajo":
        this._notificacion.click.subscribe((e: MouseEvent) => {
          this.router.navigate(['logueado/detalle-ot/', this.notificacion.data.parameters.id]);
        });
        break;
    }
  }

  cerrarNotificacion() {
    this.notificationsService.remove(this._notificacion.id);
  }
}
